
import Subscribe from "./Subscribe";

const Main = ({ onFormSubmit }) => {
    return ( 
            <main className = 'main-component'>
                <section className="one">

                </section>
                <section className="two">
                    <div className="intro">
                        <h1>Stay Updated</h1>
                        <p>Join 60,000+ product managers receiving monthly update on:</p>
                    </div>
                    <div className="benefits">
                        <ul className="benefit-list">
                            <li>Product discovery and building what matters</li>
                            <li>Measuring to ensure updates are a success</li>
                            <li>And much more</li>
                        </ul>
                    </div>
                    <Subscribe onFormSubmit={onFormSubmit} /> 
                </section>
            </main>
     );
}
 
export default Main;